// removed by extract-text-webpack-plugin
module.exports = {"a-select":"_2N9okSM_Tr9c3xKx64XG5m"};


//////////////////
// WEBPACK FOOTER
// ./shared/components/FormInput/SelectStyle.scss
// module id = 954
// module chunks = 0